import {
  DeleteRounded as DeleteRoundedIcon,
  EditRounded as EditRoundedIcon,
  SentimentSatisfiedAltRounded as SentimentSatisfiedAltRoundedIcon,
  WarningRounded as WarningRoundedIcon
} from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import Barcode from 'react-barcode'

import Can from '../../Layout/Can/Can.jsx'
import ZDialog from '../../Shared/Dialogs/ZDialog.jsx'

const GatewayDetail = ({ isOpen, selectedGateway, onClose, onEdit, onDelete }) => {
  return (
    <ZDialog
      id={'gateway'}
      isOpen={isOpen}
      title={t('gateways.gatewayDetail')}
      maxWidth="sm"
      actions={selectedGateway?.fromCityeye ? (
        <Stack direction="row" spacing={1}>
          <Can action={'gateways_d'}>
            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteRoundedIcon />}
              onClick={onDelete}
            >
              {t('gateways.delete')}
            </Button>
          </Can>
          <Can action={'gateways_u'}>
            <Button
              variant="contained"
              startIcon={<EditRoundedIcon />}
              onClick={onEdit}
            >
              {t('gateways.edit')}
            </Button>
          </Can>
        </Stack>
      ) : null}
      content={
        <Stack spacing={3} sx={{ p: 2 }}>
          <Stack alignItems="center">
            <Barcode
              value={selectedGateway?.serial || ''}
              width={1.5}
              height={50}
            />
          </Stack>

          <Stack spacing={1.5}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="subtitle2" fontWeight="bold">{t('common.status')}:</Typography>
              <Typography variant="body2">{selectedGateway?.status}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="subtitle2" fontWeight="bold">{t('common.technology')}:</Typography>
              <Typography variant="body2">{selectedGateway?.technology}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="subtitle2" fontWeight="bold">{t('common.address')}:</Typography>
              <Typography variant="body2">{selectedGateway?.address || 'N/A'}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle2" fontWeight="bold">{t('gateways.reachable')}:</Typography>
              <Box display="flex" alignItems="center" gap={1}>
                {selectedGateway?.reachable ? (
                  <>
                    <SentimentSatisfiedAltRoundedIcon color="success" fontSize="small" />
                    <Typography variant="body2">{t('common.online')}</Typography>
                  </>
                ) : (
                  <>
                    <WarningRoundedIcon color="error" fontSize="small" />
                    <Typography variant="body2">{t('common.offline')}</Typography>
                  </>
                )}
              </Box>
            </Stack>
          </Stack>
        </Stack>
      }
      onClose={onClose}
    />
  )
}

export default GatewayDetail
